import React, { useState } from 'react'
import { Ratio } from 'react-bootstrap'
import styles from './index.module.css'
import { useDispatch,useSelector } from 'react-redux';
import { setRedoS } from '../../store/modules/tabplate';

export default function Btnredo() {
  const [isPressed,setIsPressed]=useState(false)
  const {jy,un}=useSelector((state)=>state.tabplate);
  const dispatch=useDispatch();

  // 功能键背景色
  const {bm}=useSelector((state)=>state.colorplate);

  function clickRedo() {
    if(un>0 && un<jy.length-1){
      const u = (un===0) ? jy.length-1 : un
      const id=jy[u+1].id
      const dnew=jy[u+1].dnew
      dispatch(setRedoS({nid:id,nnew:dnew,un:u+1}));
    };
  };

  const handleMouseDown = () => {
    setIsPressed(true);
  };
  const handleMouseUp = () => { 
    setIsPressed(false);
    clickRedo()
  };

  return (
    <Ratio aspectRatio={"1x1"}>
    <div
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <div
        className={`${styles.b_r_adiv} ${isPressed?styles.pressed:''}`}
        style={{backgroundColor:bm}}
      >
        <img src='./pic/reply.svg' alt='' className={styles.b_r_img}/>
      </div>
    </div>
    </Ratio>
  )
}
